import { View, StyleSheet, ViewStyle } from 'react-native'
import { useBreakpoints, ResponsiveValue } from './hooks/useBreakpoints'
import { spacing } from './types'

type Gap = keyof typeof spacing
type StackAlign = 'left' | 'center' | 'right'

interface StackProps {
	children: React.ReactNode
	gap?: Gap | ResponsiveValue<Gap>
	align?: StackAlign | ResponsiveValue<StackAlign>
	style?: ViewStyle
}

const alignMap = {
	left: 'flex-start',
	center: 'center',
	right: 'flex-end',
} as const

export function Stack({ children, gap = 'sm', align, style }: StackProps) {
	const { value } = useBreakpoints()

	const gapValue = typeof gap === 'object' ? value(gap) : gap

	const alignValue = typeof align === 'object' ? value(align) : align

	return (
		<View
			style={[
				styles.container,
				{
					gap: spacing[gapValue],
					alignItems: alignValue ? alignMap[alignValue] : undefined,
				},
				style,
			]}
		>
			{children}
		</View>
	)
}

const styles = StyleSheet.create({
	container: {
		width: '100%',
	},
})
